const atcObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const target = entry.target.closest('.product-wrapper').querySelector('.sticky-atc');
      if (target !== null) {
        entry.isIntersecting ? target.classList.remove('active') : target.classList.add('active');
      }
    });
  },
  {
    threshold: 0.25,
  }
);

atcObserver.observe(document.querySelector('#AddToCartButton'));
document.querySelector('.sticky-atc').addEventListener('click', () => {
  document.querySelector('.product-form').scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
});

if (document.querySelector('.gallery-zoom')) {
  const zoom_container = document.querySelector('.gallery-zoom');

  document.querySelectorAll('.product__media-item:not(.media-video)').forEach((item) => {
    item.addEventListener('click', function () {
      let img = item.querySelector('img').src.replace('&width=1440', '&width=2048');

      document.body.classList.add('drawer--open');
      zoom_container.classList.add('gallery-zoom--active');
      zoom_container.querySelector('img').src = img;
    });
  });

  zoom_container.addEventListener('click', function () {
    document.body.classList.remove('drawer--open');
    zoom_container.classList.remove('gallery-zoom--active');
  });
}

if (document.querySelector('.product__info > .linked-products')) {
  const linkedProducts = document.querySelector('.product__info > .linked-products');
  const variantOptions = linkedProducts.querySelectorAll('.variant-option');

  variantOptions.forEach((item) => {
    const legend = item.closest('fieldset').querySelector('legend');
    const originalText = legend.textContent;

    item.addEventListener('mouseenter', () => legend.textContent = item.getAttribute('aria-label'))
    item.addEventListener('mouseleave', () => legend.textContent = originalText);
  });
}

// Slider controls
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.main-carousel');
  const wrapper = document.querySelector('.main-carousel__list');
  if (!container || !wrapper) return;

  setTimeout(() => (wrapper.scrollLeft = 0), 100);

  const btnPrev = container.querySelector('.main-carousel__arrow--prev');
  const btnNext = container.querySelector('.main-carousel__arrow--next');
  const items = Array.from(wrapper.children).filter(el => !el.classList.contains('spacer'));
  let index = 0;

  function isFullyInView(item) {
    const w = wrapper.getBoundingClientRect();
    const r = item.getBoundingClientRect();
    return r.left >= w.left && r.right <= w.right;
  }

  function updateButtons() {
    if (btnPrev) btnPrev.classList.toggle('inactive', isFullyInView(items[0]));
    if (btnNext) btnNext.classList.toggle('inactive', isFullyInView(items[items.length - 1]));
  }

  updateButtons();

  const scrollOpts = { inline: 'start', block: 'nearest', behavior: 'smooth' };

  btnNext?.addEventListener('click', () => {
    if (index < items.length - 1) {
      index++;
      items[index].scrollIntoView(scrollOpts);
    }
  });

  btnPrev?.addEventListener('click', () => {
    if (index > 0) {
      index--;
      items[index].scrollIntoView(scrollOpts);
    }
  });

  // keep index & buttons in sync on manual scroll
  let raf;
  wrapper.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const { left, width } = wrapper.getBoundingClientRect();
      const centerX = left + width / 2;

      let closest = 0, min = Infinity;
      items.forEach((item, i) => {
        const r = item.getBoundingClientRect();
        const cx = r.left + r.width / 2;
        const d = Math.abs(cx - centerX);
        if (d < min) { min = d; closest = i; }
      });

      index = closest;
      updateButtons();
    });
  });

  // optional: after programmatic scroll completes, refresh buttons
  wrapper.addEventListener('scrollend', updateButtons);
});
